import Footer from "../../components/Footer";
import TopHeader from "../../components/TopHeader";

export default function Apropos() {
  return (
    <>
      <TopHeader btn={true} />
      <div className="container mt-40 mb-80">
        <div className="col-md-8 mx-auto">
          <h2 className="grey500">A propos de Twyny</h2>
          <ol className="mt-40">
            <h4 className="grey500">
              <li> Qu'est-ce que Twyny </li>
            </h4>
            <p className="body mt-14 grey66 bold500">
              Twyny est une plateforme innovante qui facilite l'achat et la
              planification de services professionnels variés tels que la pose
              de papier peint, les services de pelouse, les cours de langue en
              ligne, des conseils juridiques, des rendez-vous chez le coiffeur
              ou encore les services d’un photographe. Accessible via{" "}
              <a href="#" className="text-decoration-none link ">
                www.Twyny.com
              </a>
              , Twyny collabore exclusivement avec des prestataires locaux qui
              répondent à des normes de performance strictes. Tous les
              professionnels de service sont rigoureusement sélectionnés,
              assurés et agréés si nécessaire. Les prestataires compétissent
              pour répondre à vos besoins spécifiques en fonction du prix, de la
              qualité et de la disponibilité, vous offrant ainsi une
              tranquillité d'esprit avec des prix fixés à l'avance, une
              planification facile et une garantie de satisfaction.
            </p>

            <h4 className="grey500 mt-24">
              <li>Quels types de services sont disponibles </li>
            </h4>
            <p className="body grey66 mt-13">
              Twyny propose une large gamme de services professionnels, divisés
              en cinq catégories principales :
            </p>
            <ul>
              <li className="body mt-16 grey66 bold500">
                <span className="link bold500">Travaux Maison et Bureau :</span>{" "}
                Revêtement de sol, services de pelouse, services de sécurité et
                surveillance, réparations d’appareils électroménagers, etc.
              </li>
              <li className="body mt-16 grey66 bold500">
                <span className="link bold500">Services professionnels :</span>{" "}
                Réparation d'appareils mobiles, nettoyage et lavage de
                véhicules, garde d’enfants, soins vétérinaires, etc.
              </li>
              <li className="body mt-16 grey66 bold500">
                <span className="link bold500">Santé et médical :</span> Soins
                infirmiers à domicile, acupuncture, soins paramédicaux,
                thérapies alternatives, etc.
              </li>
              <li className="body mt-16 grey66 bold500">
                <span className="link bold500">Salons de beauté et Spa :</span>{" "}
                Coiffeur, soins de la peau, maquillage permanent, épilation,
                etc.
              </li>
              <li className="body mt-16 grey66 bold500">
                <span className="link bold500">
                  Organisations d’événements :
                </span>{" "}
                Traiteurs, divertissement et animation, services de ballons,
                etc.
              </li>
            </ul>
            <h4 className="grey500 mt-24">
              <li>Comment fonctionnent les services de Twyny ?</li>
            </h4>
            <p className="body mt-14 grey66 bold500">
              Pour acheter un service via Twyny, vous pouvez naviguer sur la
              plateforme, sélectionner une page de service et ajouter le service
              à votre panier. Chaque service est accompagné d'un périmètre de
              travail prédéfini et d'un prix fixe, vous permettant de connaître
              exactement ce qui est inclus. Lors du paiement, vous choisissez la
              date et l'heure de votre service parmi les créneaux disponibles.
              Selon le service, vous pouvez choisir un fournisseur spécifique ou
              laisser Twyny sélectionner le meilleur prestataire en fonction des
              performances. Pour les services chez le professionnel un courriel
              de confirmation est envoyé après la commande, suivi d’un rappel 24
              heures avant le rendez-vous. Pour les services à domicile, le
              courriel de confirmation inclut le nom, la photo et le numéro de
              téléphone du technicien. Pour les services en ligne, un lien de
              connexion est transmis.
            </p>
            <h4 className="grey500 mt-24">
              <li> Où Twyny Services est-il disponible ?</li>
            </h4>
            <p className="body mt-14 grey66 bold500">
              Twyny Services est actuellement disponible en France. Il est
              essentiel de vérifier que votre localisation est correcte lors de
              l'achat pour vous assurer que le service est disponible dans votre
              région.
            </p>
            <h4 className="grey500 mt-24">
              <li>
                {" "}
                Comment Twyny sélectionne-t-il les prestataires de services ?
              </li>
            </h4>
            <p className="body mt-14 grey66 bold500">
              Twyny Services est une place de marché exclusive, réservée aux
              prestataires professionnels soigneusement sélectionnés. Les
              prestataires doivent être assurés, agréés et répondre aux normes
              les plus strictes pour proposer leurs services sur Twyny.
            </p>
            <h4 className="grey500 mt-24">
              <li> Où le service aura-t-il lieu ?</li>
            </h4>
            <p className="body mt-14 grey66 bold500">
              La majorité des services proposés par Twyny sont réalisés dans
              l’établissement du prestataire, mais certains peuvent être
              effectués à domicile ou en ligne. Vous pouvez choisir l’option de
              lieu préférée avant d’ajouter le service à votre panier, qu’il
              s’agisse de « à domicile », « chez le professionnel » ou « en
              ligne ». Les détails sur le lieu d’exécution du service sont
              disponibles sur la page de détails du prestataire.
            </p>
          </ol>
        </div>
      </div>
      <Footer />
    </>
  );
}
